import { Component, OnInit, Injectable, ViewChild } from '@angular/core';
import { EventNewParams } from './event-new-params.model';

import { DialogService, DatagridService } from '../../shared/index'; //app/shared/index barrel;
import { EventsService } from '../../events/shared/events.service';
import { NavigationService } from '../../shared/navigation/navigation.service';
import { AuthService } from '../../shared/auth/auth.service';
import { UtilService } from '../../shared/util/util.service';

@Component({
  selector: 'wl-events-new',
  templateUrl: 'events-new.component.html',
  styleUrls: ['events-new.component.css'],
  providers: [EventsService, DatagridService, EventNewParams],
    standalone: false
})
export class EventsNewComponent implements OnInit {
  public _dialogService: DialogService;
  public _navService: NavigationService;
  public _eventsService: EventsService;
  public _authService: AuthService;
  public _utilService: UtilService;
  public showModal = false;
  public errorMessage: string;
  public eventNewParams: EventNewParams;
  public saving: boolean = false;
  public StartTime: string;
  public EndTime: string;

  public constructor(
    eventsService: EventsService,
    eventNewParams: EventNewParams,
    diallogService: DialogService,
    navService: NavigationService,
    authService: AuthService,
    utilService: UtilService
  ) {
    this._eventsService = eventsService;
    this.eventNewParams = eventNewParams;
    this._dialogService = diallogService;
    this._navService = navService;
    this._authService = authService;
    this._utilService = utilService;
  }

  ngOnInit() {}

  public createEvent(event: any): void {
    this.saving = true;

    // default event email to current user email.
    this._authService.getUserInfo().then((userInfo) => {
      this.eventNewParams.Email = userInfo.email;

      this._eventsService
        .createEvent(this.eventNewParams)
        .then((data: any) => {
          this.saving = false;
          this.showModal = false;
          this._navService.navigateToEvent(data);
        })
        .catch((error: any) => {
          this.saving = false;
          this.errorMessage = this._utilService.extractErrorMessage(error);
        });
    });
  }

  public reset() {
    this.eventNewParams = new EventNewParams();
  }

  public open = () => {
    this.showModal = true;
  };

  public newCancel = (): void => {
    this.showModal = false;
  };

  public startDateChanged(newDate: Date) {
    this.eventNewParams.EndDate = newDate;
  }
}
